function getMonitoredInfo(monitoredTasks, allActiveTasks) {
    let monitoredChannelSids = [];

    monitoredTasks.forEach(task => {
        task["channelSid"] = task?.channelSid ?? GetChannelSid(task);
        monitoredChannelSids.push(task);
    });

    if (monitoredChannelSids?.length > 0) {
        allActiveTasks.forEach(task => {
            task["channelSid"] = task.channelSid != null ? task.channelSid : GetChannelSid(task);
            let foundMonitoredTask = monitoredChannelSids.find(e => e.channelSid === task["channelSid"]);

            if (foundMonitoredTask?.channelSid != null) {
                task["MonitoredBy"] = JSON.parse(foundMonitoredTask.attributes).MonitoredBy;
                task["isMonitored"] = "Yes";
                task["MonitorDuration"] = foundMonitoredTask.age;
                task["reasonForMonitoring"] = foundMonitoredTask.reason;
                task["MonitoredTaskID"] = foundMonitoredTask.sid;
            }
        });
    }
    return allActiveTasks;
}

function GetChannelSid(task) {
    var jsonTaskAttr = JSON.parse(task.attributes);

    return jsonTaskAttr.channelSid != null && jsonTaskAttr.channelSid.trim() !== "" ? jsonTaskAttr.channelSid : "N/A";
}

export default getMonitoredInfo;
